import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { LockOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

interface SignInPromptDialogProps {
  open: boolean;
  onClose: () => void;
  /** Short description of what requires an account, e.g. "saving favorites" */
  action?: string;
}

const SignInPromptDialog: React.FC<SignInPromptDialogProps> = ({ open, onClose, action }) => {
  const navigate = useNavigate();

  const handleSignIn = () => {
    onClose();
    navigate('/explore');
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <LockOutlined color="primary" />
        Sign in required
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          {action
            ? `${action} requires an account.`
            : 'This action requires an account.'}{' '}
          Sign in or create a free account to continue.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button onClick={handleSignIn} variant="contained" autoFocus>
          Sign in / Create account
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SignInPromptDialog;
